import { createSelector } from '@reduxjs/toolkit';
import { selectIsDacha } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Для постоянного проживания', value: false },
  { label: 'Дача', value: true },
];

export const selectSuburbanHouseTypeFilter = createSelector(selectIsDacha, value => ({
  label: 'Тип дома',
  value: [value],
  options: OPTIONS,
}));
